module.exports = __webpack_public_path__ + "img/clothes-1.31d86e67.png";